/**
 * plugins/translatr/index.ts - Translatr Plugins for Pluggr
 * 
 * CHANGE HISTORY:
 * - 251130_1753 [pending] danielbeer: Added self-registration
 * - 251109_0820 [pending] danielbeer: Explicit exports for better compatibility
 * - 251109_0813 [pending] danielbeer: Created Translatr plugin collection
 * 
 * Collection of Pluggr plugins that extend Translatr functionality.
 * 
 * SELF-REGISTRATION:
 * These plugins register themselves with PluginRegistry on import
 */

import { registerPlugin } from '../../PluginRegistry';
import ContactDetailsPlugin from './ContactDetailsPlugin';

// Register Translatr plugins
registerPlugin({
  id: 'translatr/ContactDetails',
  name: 'Contact Details',
  description: 'Parse and format contact information',
  category: 'translatr',
  version: '1.0.0',
  author: 'OpCentral',
  tags: ['translatr', 'contacts', 'parsing'],
  hasComponent: false,
  loader: async () => ContactDetailsPlugin as any // Type mismatch - plugin has extended interface
});

// Explicit named exports
export { 
  ContactDetailsPlugin,
  manifest,
  onload,
  onunload,
  type ContactData,
  type TranslatrFormatPlugin
} from './ContactDetailsPlugin';

// Default export
export { default as ContactDetailsPluginDefault } from './ContactDetailsPlugin';

// Export plugin collection
export const translatrPlugins = [
  'ContactDetailsPlugin'
];
